import React from 'react'
import { Pipeline } from '../../../../interfaces';
import { IntlShape } from 'react-intl';
import useUser from '../../../../hooks/User';
import { useCustomeStore } from '../../../../stores/CustomeStore';
import { Switch } from '@mui/material';
import { Table } from '@tanstack/react-table';
import { PaymentTermin } from '../../../../interfaces/Termin/Termin';
import UpdateDetailTermin from '../UpdateDetailTermin';
import TerminAttachment from '../TerminAttachment';
import PreviewAttachmentTermin from '../PreviewAttachmentTermin';
import ModalPaymentTermin from '../ModalPaymentTermin';
import ModalDeleteTermin from '../ModalDeleteTermin';
import { FormikProps } from 'formik';
import { SettingMultiPipelines } from '../../../../interfaces/Settings';
import { CustomField } from '../../../../interfaces/Settings';
import MainContentTermin from './MainContentTermin';

interface CardContentTerminProps {
    pipeline: Pipeline
    modalRef: React.RefObject<HTMLDivElement>
    isLoading: boolean
    intl: IntlShape
    handleCloseModal: () => void
    switchPaidSchedule: boolean
    setSwitchPaidSchedule: (value: boolean) => void
    table: Table<PaymentTermin>
    errorTermin: boolean
    unpaymentNominal: number
    selectMultiPipeline: SettingMultiPipelines
    formik: FormikProps<any>
    terminErrors: any
    customFieldTermin: CustomField
    handleNominalChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    handleVATTerminChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    handleDateChange: (date: Date | null) => void
    isAfterToday: (date: Date) => boolean
    isBeforeToday: (date: Date) => boolean
    handleAddPaymentTermin: () => void
    closeModalRef: React.RefObject<HTMLButtonElement>
    showUpdateModal: boolean
    selectedTermin: PaymentTermin & { index: number }
    selectedTerminNumber: number
    mutateTermin: () => void
    showAttachmentModal: boolean
    terminUrl: string
    isTypeFile: boolean
    terminFiles: File | File[] | null
    handleClosePreview: () => void
    showPaymentModal: boolean
    data: PaymentTermin[]
    tempPaymentTermin: PaymentTermin[]
    setShowUpdateModal: (value: boolean) => void
    setSelectedTermin: (value: PaymentTermin & { index: number } | null) => void
    setShowDeleteModal: (value: boolean) => void
    terminKey: string
    setShowAttachmentModal: (value: boolean) => void
    showDeleteModal: boolean
    setUnpaymentNominal: React.Dispatch<React.SetStateAction<number>>
    setShowPaymentModal: (value: boolean) => void
}

const CardContentTermin = ({
    pipeline, modalRef, isLoading, intl, handleCloseModal,
    switchPaidSchedule, setSwitchPaidSchedule, table, errorTermin,
    unpaymentNominal, selectMultiPipeline, formik, terminErrors,
    customFieldTermin, handleNominalChange, handleVATTerminChange,
    handleDateChange, isAfterToday, isBeforeToday, handleAddPaymentTermin,
    closeModalRef, showUpdateModal, selectedTermin, selectedTerminNumber,
    mutateTermin, showAttachmentModal, terminUrl, isTypeFile, terminFiles,
    handleClosePreview, showPaymentModal, data, tempPaymentTermin, setShowUpdateModal,
    setSelectedTermin, setShowDeleteModal, setUnpaymentNominal, terminKey,
    showDeleteModal, setShowPaymentModal }: CardContentTerminProps) => {

    const user = useUser()
    const { companyId } = useCustomeStore()

    return (
        <>
            <div className="card rounded">
                <div className="card-body pt-5">
                    {isLoading && (
                        <div className="loading-overlay">
                            <div className="loader"></div>
                        </div>
                    )}
                    {
                        user.data.company_id === companyId.maspionSquare &&
                        <div className="form-group h-100">
                            <div className="d-flex align-items-center h-100 justify-content-end">
                                <label className='form-label fs-6 fw-bolder text-dark mb-0 me-3'>{intl.formatMessage({ id: 'FORM.ACTION.PAID_SCHEDULE' })}</label>
                                <Switch
                                    checked={switchPaidSchedule}
                                    onChange={(e) => setSwitchPaidSchedule(e.target.checked)}
                                    inputProps={{ 'aria-label': 'secondary checkbox' }}
                                />
                            </div>
                        </div>
                    }
                    {/* Main Content */}
                    <MainContentTermin
                        switchPaidSchedule={switchPaidSchedule}
                        pipeline={pipeline}
                        errorTermin={errorTermin}
                        intl={intl}
                        table={table}
                        unpaymentNominal={unpaymentNominal}
                        selectMultiPipeline={selectMultiPipeline}
                        formik={formik}
                        customFieldTermin={customFieldTermin}
                        handleNominalChange={handleNominalChange}
                        handleVATTerminChange={handleVATTerminChange}
                        handleDateChange={handleDateChange}
                        isAfterToday={isAfterToday}
                        isBeforeToday={isBeforeToday}
                        terminErrors={terminErrors}
                        handleAddPaymentTermin={handleAddPaymentTermin}
                    />
                    {/* End: Main Content */}

                    <div className="col-12 text-end mt-4">

                        {
                            !switchPaidSchedule && tempPaymentTermin.length > 0 && (
                                <>
                                    <button
                                        className={`btn btn-success ${formik.isSubmitting ? 'disabled' : ''}`}
                                        data-kt-indicator={formik.isSubmitting ? 'on' : 'off'}
                                        data-kt-in
                                        onClick={() => formik.handleSubmit()}
                                        disabled={formik.isSubmitting}
                                    >
                                        <span className='indicator-label'>
                                            <i className='fa fa-save me-2'></i>
                                            {intl.formatMessage({ id: "FORM.LABEL.SAVE_CHANGE" })}
                                        </span>
                                        <span className="indicator-progress">
                                            Loading... <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                        </span>
                                    </button>
                                </>
                            )
                        }
                    </div>
                </div>

            </div>


            {showUpdateModal && selectedTermin && (
                <UpdateDetailTermin
                    termin={selectedTermin}
                    pipeline={pipeline}
                    onSuccess={() => {
                        setSelectedTermin(null);
                        mutateTermin();
                    }}
                    terminNumber={selectedTerminNumber}
                    customFieldTermin={customFieldTermin}
                    mutateTermin={mutateTermin}
                    setUnpaymentNominal={setUnpaymentNominal}
                />
            )
            }

            {
                showAttachmentModal && terminUrl && isTypeFile === false && (
                    <TerminAttachment // pop up attachment
                        pipeline={pipeline}
                        title={customFieldTermin[terminKey]?.name ?? ''}
                        url={terminUrl}
                    />
                )
            }

            {
                showAttachmentModal && terminFiles && isTypeFile === true && (
                    <PreviewAttachmentTermin
                        files={terminFiles!}
                        onClose={handleClosePreview}
                    />
                )
            }

            {
                showPaymentModal && (
                    <ModalPaymentTermin
                        termin={selectedTermin!}
                        pipeline={pipeline}
                        setShowPaymentModal={setShowPaymentModal}
                        dataTermin={data}
                    />
                )
            }

            {
                showDeleteModal && (
                    <ModalDeleteTermin
                        termin={selectedTermin!}
                        pipeline={pipeline}
                        terminNumber={selectedTerminNumber}
                        onSuccess={() => {
                            setShowDeleteModal(false);
                            setSelectedTermin(null);
                            mutateTermin()
                        }}
                        setUnpaymentNominal={setUnpaymentNominal}
                    />
                )
            }
        </>
    )
}

export default CardContentTermin